import {
  ClbTable,
  type ClbTableProps,
} from "@celebration/react/ClbTable/ClbTable";
import type { TableProps } from "@components/contracts/Table.types";

export const CelebrationTable = <DataType extends Record<string, unknown>>({
  data,
  columns,
  loading = false,
}: TableProps<DataType>) => (
  <ClbTable
    data={data}
    columns={columns as unknown as ClbTableProps<DataType>["columns"]}
    loading={loading}
    config={{
      headerType: "fixed",
      defaultCellAlign: "left",
      tableEmpty: {
        title: "Não há dados disponíveis no momento",
        icon: "data-base",
      },
      enableColumnReorder: false,
    }}
  />
);
